<!--==========================
=            TODO            =
===========================-->
<template>
	<v-row>
		<v-col clas="col-12 col-md-12 col-sm-12">
			<v-card class="rounded-lg "
					:class="$vuetify.theme.dark ? 'card-dark' : 'card-light'">
				<v-form>
					<v-banner single-line
							  @click:icon="alert">
						<v-icon slot="icon"
								color="warning"
								size="36">
							mdi-wifi-strength-alert-outline
						</v-icon>

						<v-btn :class="{ completed }"
							   @click="$emit('on-toggle')"
							   v-if="!isEditing">{{ description }}</v-btn>
						<v-form v-else
								class="flex-grow-1"
								@submit.prevent="finishEditing()">
							<v-input type="text"
									 class="form-control"
									 v-model="newTodoDescription"
									 @blur="finishEditing()"
									 ref="newTodo" />
						</v-form>


						<template v-slot:actions>
							<v-btn @click="startEditing()"
								   icon>
								<v-icon color="blue lighten-1">edit</v-icon>
							</v-btn>
							<v-btn @click="$emit('on-delete')"
								   icon>
								<v-icon color="red lighten-1">delete</v-icon>
							</v-btn>

						</template>
					</v-banner>

				</v-form>
			</v-card>

		</v-col>
	</v-row>

</template>
<script>
	export default {
		data() {
			return {
				isEditing: false,
				newTodoDescription: ""
			};
		},
		props: {
			description: String,
			completed: Boolean
		},
		methods: {
			startEditing() {
				if (this.isEditing) {
					this.finishEditing();
				} else {
					this.newTodoDescription = this.description;
					this.isEditing = true;
					this.$nextTick(() => this.$refs.newTodo.focus());
				}
			},
			finishEditing() {
				this.isEditing = false;
				this.$emit("on-edit", this.newTodoDescription);
			}, 
      alert () {
        alert('Hello, World!')
      },
    
		}
	};
</script>

<style lang="scss"
	   scoped>
	.completed {
		text-decoration: line-through;
	}
</style>


<!--====  End of TODO  ====-->
